import styled from "styled-components";
import { theme } from "../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { ToggleIconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";

export const Item = styled.div`
    margin-bottom: ${theme.space[4]}px;
    padding-bottom: ${theme.space[3]}px;
`;

export const ListItem = styled.div`
    display: flex;
    justify-content: space-between;
    padding: ${theme.space[2]}px 0;
    border-bottom: 1px solid ${theme.colors.grey7};

    ${Type.Strong},
    ${Item} {
        .professional-theme & {
            color: ${theme.colors.primaryWhite};
        }
    }

    .professional-theme & {
        border-bottom: 1px solid ${theme.colors.grey1};
    }
`;

export const Header = styled.button`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-top: ${theme.space[2]}px;
    text-align: start;
    background-color: transparent;
    border: none;

    ${ToggleIconWrapper} {
        position: relative;
        top: 2px;
        margin-left: ${theme.space[1]}px;

        .professional-theme & {
            color: ${theme.colors.primaryWhite};
        }
    }

    html[dir="rtl"] & {
        ${ToggleIconWrapper} {
            margin-left: 0;
            margin-right: ${theme.space[1]}px;
        }
    }
`;

export const Toggle = styled.div<{ isOpen?: boolean }>`
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
    width: 100%;
`;

export const OriginalPrice = styled.span`
    margin-right: ${theme.space[1]}px;
    font-size: 13px;
    text-decoration: line-through;
    color: ${theme.colors.grey7};

    .professional-theme & {
        color: ${theme.colors.primaryWhite};
    }

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[1]}px;
    }
`;

export const PriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    ${Type.Strong} {
        margin-bottom: 0;
    }
`;
